import { STEPPER_LABELS } from '../../../components/Stepper/lang';
import { PAGE_TEXT as APPLICATION_FORM_TEXT } from '../../Application/components/ApplicationForm/lang';
import { PAGE_TEXT as NOMINATION_PAGE_TEXT } from '../../Nomination/components/lang';

export const PAGE_COMMON_TEXT = {
  TITLE: 'Application Details',
  SIDEBAR_TEXT: {
    STUDENT_APPLICATION: 'Student Application',
    SUPERVISOR_NOMINATION: 'Supervisor Nomination',
    DORPGS_ASSESSMENT: 'DoRPgS Assessment',
    DRC_APPROVAL: 'D/SRC Approval',
    HOD_DOS_ASSESSMENT: 'HoD/DoS Approval',
    FRC_ASSESSMENT: 'FRC/SB Approval',
    PANEL_SELECTION: 'Panel Selection',
    GS_DECISION: 'GS Decision',
    APPROVAL: 'Approval',
    SCHOLARSHIP_EVALUATION: {
      TITLE: 'Scholarship Evaluation',
      HINT: 'Please note that this applicant is exempted from the Scholarship Evaluation process.',
    },
    CONDITION_CHECK: 'Condition Check',
    DECLARATION: 'Declaration',
    VISA_APPLICATION: 'Visa Application',
    QUALIFICATION_CHECK: 'Qualification Check',
  },
  BACK: 'Back',
  NA: 'N/A',
};

const RESEARCH_EXPERIENCE_FORM_TEXT =
  APPLICATION_FORM_TEXT.OTHER_INFORMATION.RESEARCH_EXPERIENCE;
const {
  TITLE: RESEARCH_EXPERIENCE_SUBTITLE,
  ...OTHER_RESEARCH_EXPERIENCE_FORM_TEXT
} = RESEARCH_EXPERIENCE_FORM_TEXT;

const EMPLOYMENT_FORM_TEXT = APPLICATION_FORM_TEXT.OTHER_INFORMATION.EMPLOYMENT;
const { TITLE: EMPLOYMENT_SUBTITLE, ...OTHER_EMPLOYMENT_FORM_TEXT } =
  EMPLOYMENT_FORM_TEXT;

const PROFESSIONAL_QUALIFICATION_TEXT =
  APPLICATION_FORM_TEXT.OTHER_INFORMATION.PROFESSIONAL_QUALIFICATION;
const {
  TITLE: PROFESSIONAL_QUALIFICATION_SUBTITLE,
  ...OTHER_PROFESSIONAL_QUALIFICATION_TEXT
} = PROFESSIONAL_QUALIFICATION_TEXT;

const TRAINING_TEXT = APPLICATION_FORM_TEXT.OTHER_INFORMATION.TRAINING;
const { TITLE: TRAINING_SUBTITLE, ...OTHER_TRAINING_TEXT } = TRAINING_TEXT;

const ACTIVITY_TEXT = APPLICATION_FORM_TEXT.OTHER_INFORMATION.EXTRA_ACTIVITY;
const { TITLE: ACTIVITY_SUBTITLE, ...OTHER_ACTIVITY_TEXT } = ACTIVITY_TEXT;

export const APPLICATION_TEXT = {
  APPLICANT_PARTICULAR: 'Applicant Particular',
  PROGRAMME_CHOICE: {
    SECTION_TITLE: 'Programme Choice',
    SUBTITLE: 'Programme Choice',
    INTEND_ACCEPT:
      'The applicant intend to accept offer if no research studentship is provided',
    DUAL_PHD:
      'Dual PhD Degree Programmes/Joint PhD Supervision Programmes Leading to a PolyU Degree',
    ...APPLICATION_FORM_TEXT.PROGRAMME,
  },
  ACADEMIC_QUALIFICATION: {
    NA: 'N/A',
    SECTION_TITLE: 'Academic Qualification',
    DEGREE_LEVEL: 'Level of Degree',
    INSTITUTION_NAME: 'Name of Institution',
    INSTITUTION_COUNTRY: 'Country of Institution',
    OFFICIAL_GPA: 'Award/Cum. GPA or Avg Mark (Reference)',
    OFFICIAL_AWARD_GPA: 'Official Award/Cum. GPA or Avg Mark',
    CALCULATED_GPA: 'Tool Calculated Cum. GPA or Avg Mark',
    NO_OFFICIAL_GPA: 'No Award/Cum. GPA or Avg Mark',
    CLASS_RANK: 'Rank in Class',
    NO_CLASS_RANK: 'No official rank in class with proof',
    NO_AWARD_CLASSIFICATION: 'No award classification with proof',
    PROOF_OF_GPA:
      'Proof of GPA (including the grading system), Rank in class and/or Award Classification has to be included in the file uploaded in B3.',
    ...APPLICATION_FORM_TEXT.QUALIFICATION.ACADEMIC_QUALIFICATION,
  },
  LANGUAGE_QUALIFICATION: {
    TITLE: 'Language Qualification',
    TEST_TYPE: 'Test Type',
    TEST_DATE: 'Test Date',
    EXPECTED_UPDATED_DATE: 'Expected Result Update Date',
    LISTENING: 'Listening',
    READING: 'Reading',
    WRITING: 'Writing',
    SPEAKING: 'Speaking',
    OVERALL_SCORE: 'Overall Score',
  },
  OTHER_TEST: {
    TITLE: 'Other Test',
    TEST_TYPE: 'Test Type',
    TEST_DATE: 'Test Date',
    DATE_OF_RESULT: 'Date of Result',
    EXPECTED_UPDATED_DATE: 'Expected Result Update Date',
    QUANTITATIVE: 'Quantitative',
    ANALYTICAL_WRITING: 'Analytical Writing',
    VERBAL: 'Verbal',
    INTEGRATED_REASONING: 'Integrated Reasoning',
    TOTAL_SCORE: 'Total Score',
    DATA_INSIGHT: 'Data Insights',
    PERCENTILE: 'Percentile',
  },
  PUBLICATION: {
    TITLE: 'Publications',
    SUBTITLE: 'Publication',
    PUBLICATION_LIST_NOTE:
      '(The approved Discipline-specific Publication List can be used by the respective departments/schools.)',
    AUTHORS: 'Authors',
    PUBLISHER_NAME: 'Publisher Name',
    PUBLICATION_TYPE: 'Publication Type',
    ISSUE_NO: 'Issue/Page/Article No.',
    PUBLICATION_TITLE: 'Publication Title',
    PUBLICATION_STATUS: 'Publication Status',
    PUBLICATION_DATE: 'Publication Date',
    APPLICANT_ROLE: 'Applicant Role',
    PEER_REVIEWED: 'Peer-reviewed',
    CITATION_INFO: 'Citation Information',
    PUBLICATION_URL: 'Publication URL',
    YES: 'Yes',
    NO: 'No',
  },
  MERITS: {
    TITLE: 'Prize & Award (Merit)',
    SUBTITLE: 'Merit',
    MERIT_LIST_NOTE:
      '(The approved Prestigious Merit List will be 3 scores each, the list can be used by all Departments/ Schools. All other merits at or above university level will be 1 score each.)',
    MERIT_NAME: 'Name of Merit',
    AWARD_DATE: 'Award Date',
    COUNTRY: 'Country/Region',
    AWARD_INSTITUTION: 'Awarding Institution',
    ATTAINMENT_MEANS: 'Means of Attainment',
  },
  ACADEMIC_REFEREE: {
    TITLE: 'Academic Reference',
    SUBTITLE: 'Academic Referee',
    REFEREE_TITLE: 'Title',
    REFEREE_NAME: 'Name of Referee',
    INSTITUTION: 'Institution',
    POSITION: 'Position',
    RELATIONSHIP: 'Relationship',
    EMAIL: 'Email',
  },
  RESEARCH_EXPERIENCE: {
    TITLE: 'Research Plan and Vision Statement',
    SUBTITLE: RESEARCH_EXPERIENCE_SUBTITLE,
    ...OTHER_RESEARCH_EXPERIENCE_FORM_TEXT,
  },
  EMPLOYMENT: {
    TITLE: 'Work Experience',
    SUBTITLE: EMPLOYMENT_SUBTITLE,
    ...OTHER_EMPLOYMENT_FORM_TEXT,
  },
  PROFESSIONAL_QUALIFICATION: {
    TITLE: 'Professional Qualification',
    SUBTITLE: PROFESSIONAL_QUALIFICATION_SUBTITLE,
    ...OTHER_PROFESSIONAL_QUALIFICATION_TEXT,
  },
  TRAINING: {
    TITLE: 'Training/Internship',
    SUBTITLE: TRAINING_SUBTITLE,
    ...OTHER_TRAINING_TEXT,
  },
  ACTIVITY: {
    TITLE: 'Extra Curricular Activity',
    SUBTITLE: ACTIVITY_SUBTITLE,
    ...OTHER_ACTIVITY_TEXT,
  },
  ADDITIONAL_DOCUMENTS: {
    TITLE: 'Additional Documents',
    SUBTITLE: 'Additional Documents',
    CAPTION: 'Type of Documents',
  },
  SUPPORTING_DOCUMENT: 'Supporting Documents',
  NA: 'N/A',
};

export const NOMINATION_TEXT = {
  SUPERVISORS: 'Supervisors',
  ...NOMINATION_PAGE_TEXT,
};

export const APPLICATION_LIST_TEXT = {
  APPLICATION_PARTICULARS: 'Application Particulars',
  SECTION_LIST: {
    SECTION_A: 'Section A',
    SECTION_B: 'Section B',
    SECTION_C: 'Section C',
    SECTION_D: 'Section D',
    SECTION_E: 'Section E',
    SECTION_F: 'Section F',
    SECTION_G: 'Section G',
    SECTION_H: 'Section H',
    SECTION_I: 'Section I',
  },
  SECTION_CONTENT: {
    HKPFS: 'HKPFS',
    HKPFS_FULL: 'Hong Kong PhD Fellowship Scheme (HKPFS)',
    DISTINCTIVE_SCHOLARSHIP: 'Distinctive Scholarship',
    PROGRAMME_CHOICE: 'Programme Choice',
    ACADEMIC_QUALIFICATION: 'Academic Qualification',
    PUBLICATION: 'Publications',
    MERIT: 'Prize & Award (Merit)',
    ACADEMIC_REFEREE: 'Academic Reference',
    PROFESSIONAL_QUALIFICATION: 'Professional Qualification',
    TRAINING: 'Training/Internship',
    LANGUAGE_QUALIFICATION: 'Language Qualification',
    OTHER_TEST: 'Other Test',
    EMPLOYMENT: 'Work Experience',
    ACTIVITY: 'Extra Curricular Activity',
    RESEARCH_EXPERIENCE: 'Research Plan and Vision Statement',
    ADDITIONAL_DOCUMENTS: 'Additional Documents',
    APPLICATION_DECLARATIONS: 'Application Declarations',
  },
};

export const DORPGS_LIST_TEXT = {
  GSB1: STEPPER_LABELS.GSB1.LABEL,
  ACADEMIC_QUALIFICATION: STEPPER_LABELS.ACADEMIC_QUALIFICATION.LABEL,
  PUBLICATION: STEPPER_LABELS.PUBLICATION.LABEL,
  MERIT: STEPPER_LABELS.MERIT.LABEL,
  REFEREE_REPORT: STEPPER_LABELS.REFEREE_REPORT.LABEL,
  INTERVIEW_PANEL: STEPPER_LABELS.INTERVIEW_PANEL.LABEL,
  SCORES_ON_APPLICANT: STEPPER_LABELS.SCORES_ON_APPLICANT.LABEL,
  DECLARATION: STEPPER_LABELS.DECLARATION.LABEL,
};
